import styled, { css } from 'styled-components'
import {
  Box,
  Button,
  DropdownItem,
  FlatButton,
  truncateStyles,
} from '@sketch/components'
import { ReactComponent as Plus } from '@sketch/icons/plus-17'
import { ReactComponent as MarkdownLink } from '@sketch/icons/markdown-link-share-17'
import { ReactComponent as Sliders } from '@sketch/icons/sliders-3-17'

export const TriggerButton = styled(Button).attrs({ size: '32' })(
  ({ theme }) => css`
    padding: 6px 8px 6px 12px; /* stylelint-disable-line scales/space */
    font-size: ${theme.fontSizes.D};
    font-weight: ${theme.fontWeights.regular};
    box-shadow: none;

    &,
    :hover,
    :focus,
    :active {
      color: ${theme.colors.foreground.secondary.A};
    }

    &[disabled] {
      opacity: 0.5;
    }

    &[aria-expanded='true'],
    &[aria-current='true'],
    &.active {
      border: 1px solid ${theme.colors.sketch.F};
      background-color: ${theme.colors.sketch.F};
      color: ${theme.colors.sketch.A};

      &:hover {
        background-color: ${theme.colors.sketch.F};
      }
    }
  `
)

export const DropdownItemStyled = styled(DropdownItem)(
  ({ theme }) => css`
    font-weight: ${theme.fontWeights.semibold};
  `
)

export const DropdownHeader = styled(Box)(
  ({ theme }) => css`
    margin-left: 20px;
    padding: 8px 0;

    color: ${theme.colors.foreground.secondary.D};
    font-size: ${theme.fontSizes.B};
    font-weight: ${theme.fontWeights.regular};

    text-align: left;
    pointer-events: none;
  `
)

export const DropdownItemDescription = styled.span(
  ({ theme }) => css`
    display: block;
    margin: 4px 0 0 0;
    line-height: 1.2;
    white-space: initial;
    color: ${theme.colors.foreground.secondary.D};
    font-size: ${theme.fontSizes.C};
    font-weight: ${theme.fontWeights.regular};
  `
)

export const PreviewHeader = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;

    ${truncateStyles};
    width: 100%;
    min-width: '150px';
    white-space: initial;

    padding-left: 20px;
    padding-right: 12px;

    span {
      font-weight: ${theme.fontWeights.regular};
      color: ${theme.colors.foreground.secondary.D};
      font-size: ${theme.fontSizes.B};
    }
  `
)

const iconStyles = css`
  width: 17px;
  height: 17px;
  flex: none;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const NewButton = styled(FlatButton)(
  ({ theme }) => css`
    width: 41px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${theme.radii.large};

    &:hover {
      background-color: ${theme.colors.state.hover};

      svg {
        color: ${({ theme }) => theme.colors.foreground.secondary.A};
      }
    }
  `
)

export const PlusIcon = styled(Plus)`
  ${iconStyles}
`

export const LinkIcon = styled(MarkdownLink)`
  ${iconStyles}
`

export const SlidersIcon = styled(Sliders)`
  ${iconStyles}
`

export const ActionButton = styled(FlatButton)`
  padding: 8px 12px 8px;

  &:hover {
    svg {
      color: ${({ theme }) => theme.colors.foreground.secondary.A};
    }
  }
`

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: -8px;
  margin-top: 4px;
`

export const PreviewItem = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;

    ${truncateStyles};
    width: 100%;
    min-width: '150px';
    height: 40px;
    white-space: initial;
    padding: 8px 12px;
    border-radius: ${theme.radii.large};
    cursor: pointer;
    margin: 8px 0;

    @media (hover: hover) {
      &:hover,
      &:focus-visible,
      &:active,
      &[aria-selected='true']:not([aria-disabled='true']) {
        background: ${theme.colors.background.tertiary.C};
        color: ${theme.colors.foreground.secondary.A};
      }
    }
  `
)

export const PreviewList = styled.div`
  padding: 0 8px;

  & > div:first-child {
    margin-top: 0;
  }

  & > div:last-child {
    margin-bottom: 0;
  }
`

export const ItemName = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary.B};
    font-size: ${theme.fontSizes.D};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.lineHeights.default};
    text-align: left;
    width: 256px;
    ${truncateStyles};
  `
)
